export const DialogStyle = {
  noBorder: {
    border: "none",
    padding: "0px 16px 0px 16px",
    textAlign: "center",
  },

  width: { width: "100%" },
  textFieldStyles: { width: "100%", mt: 1 },

  emailWidth: {
    display: "flex",
    // justifyContent: "space-between",
    gap: "16px",
  },
  formControl: { width: "48%" },

  addBox: { marginTop: "16px" },

  box: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "16px",
    border: "1px solid #cccccc",
    borderRadius: "6px",
    padding: "16px",
    gap: "12px",
  },

  button: {
    display: "flex",
    justifyContent: "center",
  },
  errorIcon: {
    backgroundColor: "#FBF2D6",
    flexDirection: "row",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "4px",
  },
  error: { width: "16px", color: "#C18803" },

  divider: {
    marginTop: "24px",
    marginBottom: "24px",
  },

  excel: { width: "100%", marginTop: "16px" },

  emailButton: { display: "flex", justifyContent: "center", p: "16px" },

  import: {
    marginTop: "16px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  userBox: {
    textAlign: "center",
    boxSizing: "border-box",
  },
  firstSpan: {
    borderBottom: "1px solid #f0f0f0",
    borderTop: "1px solid #f0f0f0",
    width: "47%",
    height: "1px",
    display: "inline-block",
    verticalAlign: "middle",
    marginBottom: 0,
  },
  span: {
    fontSize: "14px",
    fontWeight: 400,
    backgroundColor: "#fff",
    paddingRight: "10px",
    display: "inline-block",
    width: "5%",
    padding: "0 1px",
    verticalAlign: " middle",
  },
  image: {
    width: 50,
  },

  MainBox: {
    // width: "85%",
    overflow: "scroll",
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    p: "10px 10px 0px 10px"
  },
  dealershipBox: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
  },
  imageBox: {
    border: "1px solid #cccccc",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    borderRadius: "5px",
    justifyContent: "center",
    width: "20vw",
    height: "214px",
  },
  withoutImage: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
  },
  mainContactBox: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },
  associatebutton: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
    p: "5px 0px 10px 0px"
  },
  managerBox: {
    display: "flex",
    flexDirection: "row",
    gap: "2%",
    width: "100%",
    p: "5px 0px 10px 0px"
  },
  associateBox: {
    width: "25%",
    display: "flex",
    border: "1px #ccc solid",
    borderRadius: "6px",
    gap: "8px",
    padding: "16px",
    flexWrap: "wrap",
    alignContent: "flex-start",
    overflow: "scroll",
    flexDirection: "column",
  },
  chipBox: { display: "flex", flexWrap: "wrap", gap: "8px" },
  chip: {
    borderRadius: "10px",
    display: "flex",
    flexDirection: "row",
    "& .MuiChip-deleteIcon": {
      color: "#cccccc",
    },
  },
  openingHourBox: {
    display: "flex",
    flexDirection: "row",
    gap: "16px",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  dealerButton: {
    display: "flex",
    justifyContent: "flex-end",
    pr: 5
  },
  referralBox: {
    display: "flex",
    gap: "10px",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  }
};
